import script from "./ComputeTaskFilesList.vue?vue&type=script&lang=ts&setup=true"
export * from "./ComputeTaskFilesList.vue?vue&type=script&lang=ts&setup=true"

import "./ComputeTaskFilesList.vue?vue&type=style&index=0&id=e0dbde42&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0dbde42"]])

export default __exports__